(function () {
    function moviePosterInformation($interval, $sce, $timeout, $rootScope) {
        return {
            restrict: 'E',
            template: '<div ng-include="getTemplateUrl()"></div>',
            scope: {
                movie: "=",
                filteredShowtimes: '=totalShowings',
                ticketsOnSale: "=",
                movieFormatType: "=",
                alignText: "@",
                showImage: "@",
                cappedWidth: "@",
                cardType: "@",
                disabledShowtimesDir: "=disabledshowtimes",
                disabledShowtimesRangeDir: "=disableddaterange",
                notSellableShowtimes: "=notsellableshowtimes"
            },
            link: function (scope, element, attrs) {
                scope.customClasses = "";

                if ('cardType' in attrs) {
                    scope.cardType = attrs['cardType'];
                }

                if (scope.cappedWidth) {
                    scope.customClasses += "capped-width";
                }

                if ('alignText' in attrs) {
                    scope.alignment = 'movie-text-align-' + attrs['alignText'];
                    scope.customClasses += " " + scope.alignment;
                }

                // movieFormatType is now the selected-formats ARRAY (mvm.selectedFormats).
                // A showtime-format group is shown when its FormatType is one of the
                // selected formats; an empty selection shows everything.  The old
                // IMAX / C Premium family expansion was removed 2026-08 - exact match
                // only, mirroring matchesFormatFilter in app.js.
                scope.showtimeFormatfilter = function (showingsFormat) {
                    var showformat = _.get(showingsFormat, '[0].FormatType');

                    if (_.isEmpty(scope.movieFormatType)) {
                        return true;
                    }

                    var selected = _.isArray(scope.movieFormatType) ? scope.movieFormatType : [scope.movieFormatType];
                    return _.some(selected, function (f) {
                        return String(f).trim() === String(showformat).trim();
                    });
                }

                scope.sellableOnline = function (filmid) {
                    if (scope.notSellableShowtimes && typeof scope.notSellableShowtimes === 'object') {
                        if (scope.notSellableShowtimes.hasOwnProperty(filmid)) {
                            var message = scope.notSellableShowtimes[filmid];
                            return message;
                        }
                    }
                    return 'true';
                }

                scope.showNotSellableModal = function (filmid) {
                    var message = scope.sellableOnline(filmid);
                    if (message !== 'true') {
                        //console.log('Broadcasting modal message for filmid:', filmid);

                        // Broadcast to $rootScope so the modal can pick it up regardless of scope isolation
                        $rootScope.$broadcast('showNotSellableModal', {
                            message: message,
                            trustedHtml: $sce.trustAsHtml(message)
                        });

                        // Small delay to ensure broadcast is processed
                        $timeout(function () {
                            $('#notSellableModal').modal('show');
                        }, 100);
                    }
                }

                // Listen for modal events at this directive's scope level
                scope.$on('showNotSellableModal', function (event, data) {
                    scope.modalMessageRaw = data.message;
                    scope.modalMessage = data.trustedHtml;
                });

                scope.titleText = function (show) {
                    // Pick one primary status message (mutually exclusive, priority order).
                    var primary = "";
                    if (!scope.ticketsOnSale) {
                        primary = 'Tickets coming soon';
                    } else if (show.ShowSoldOut) {
                        primary = 'Tickets are sold out';
                    } else if (show.TicketsSellingFast) {
                        primary = 'Almost sold out';
                    } else if (show.cancelMessage) {
                        primary = show.cancelMessage;
                    }

                    // Build pipe-separated suffixes from supplementary signals so a single
                    // bubble can advertise everything at once (event name + format override etc.).
                    // This is where the existing " | EventName" concatenation lived; the
                    // FormatOverride emergency feature appends through the same channel so its
                    // tooltip text shows up alongside any sold-out/coming-soon info on the bubble.
                    //
                    // When format IS overridden we replace EventName with the override message
                    // instead of appending it -- the EventName here typically describes the
                    // original format event (e.g., "C Premium XL"), which would be misleading
                    // once the format is no longer C Premium XL.
                    var suffixes = [];
                    if (show.IsFormatOverridden) {
                        suffixes.push('Format temporarily changed to ' + show.FormatCode + ' (previously ' + show.OriginalFormatCode + ')');
                    } else if (_.get(show, 'EventName')) {
                        suffixes.push(show.EventName);
                    }

                    if (!primary && suffixes.length) {
                        // No primary status -- show just the suffixes without a leading separator.
                        return suffixes.join(' | ');
                    }

                    var suffixString = suffixes.length ? ' | ' + suffixes.join(' | ') : '';
                    return primary + suffixString;
                }

                var disabledCinemas = {};
                scope.isDisabledShowtimeTime = function (show, showtimeRanges) {
                    if (_.has(disabledCinemas, show.CinemaID)) {
                        if (_.isEmpty(disabledCinemas[show.CinemaID])) {
                            return false;
                        } else {
                            var showtime = moment(show.StartTime);

                            if (showtime.isBetween(disabledCinemas[show.CinemaID].Start, disabledCinemas[show.CinemaID].End)) {
                                show.cancelMessage = disabledCinemas[show.CinemaID].Reason;
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } else {
                        var foundCinema = _.find(showtimeRanges, { 'CinemaId': show.CinemaID });
                        if (foundCinema) {
                            disabledCinemas[show.CinemaID] = {
                                Start: moment(foundCinema.Start),
                                End: moment(foundCinema.End),
                                Reason: foundCinema.Reason,
                            }

                            var showtime = moment(show.StartTime);
                            if (showtime.isBetween(disabledCinemas[show.CinemaID].Start, disabledCinemas[show.CinemaID].End)) {
                                show.cancelMessage = disabledCinemas[show.CinemaID].Reason;
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            disabledCinemas[show.CinemaID] = null;
                            return false;
                        }
                    }
                }

                scope.isDisabledShowtime2 = function (id, ids) {
                    return (ids.indexOf(id) > -1);
                }

                scope.getTemplateUrl = function () {
                    var url = "";

                    switch (scope.cardType) {
                        case 'movie-detail':
                            url = '/Assets/Templates/tmpl.moviePosterInformationMovieDetail.html';
                            break;
                        case 'location-detail':
                            url = '/Assets/Templates/tmpl.moviePosterInformationLocationDetail.html';
                            break;
                        case 'home-page':
                            url = '/Assets/Templates/tmpl.moviePosterInformation.html';
                            break;
                        default:
                            url = '/Assets/Templates/tmpl.moviePosterInformation.html';
                            break;
                    }
                    return url;
                };

                scope.counter = 0;
                var toggleToolTips = function () {
                    $('[data-toggle="tooltip"]').tooltip();
                };

                var intervalPromise = $interval(toggleToolTips, 1000);

                scope.$on('$destroy', function () {
                    $interval.cancel(intervalPromise);
                });
            }
        };
    }
    moviePosterInformation.$inject = ['$interval', '$sce', '$timeout', '$rootScope'];
    angular
        .module("cstudioApp.directives")
        .directive("moviePosterInformation", moviePosterInformation);
})();